import { render, staticRenderFns } from "./FiltersGallery.vue?vue&type=template&id=296d42a8&scoped=true&"
import script from "./FiltersGallery.vue?vue&type=script&lang=js&"
export * from "./FiltersGallery.vue?vue&type=script&lang=js&"
import style0 from "./FiltersGallery.vue?vue&type=style&index=0&id=296d42a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296d42a8",
  null
  
)

export default component.exports